import Cookie from 'js-cookie'

export const getCounterEndTimeCookie = (
  pageId: number,
  postFix: number | null,
) => Cookie.get(`counter_start_time_${pageId}_${postFix}`)
